import Layout from '@/views/layout'

export default {
  path: '/inner',
  name: 'Inner',
  meta: {
    id: 'A',
    title: '汇入汇款'
  },
  component: Layout,
  children: [
    {
      path: 'transfer',
      name: 'InnerTransfer',
      meta: {
        id: '101',
        title: '汇入管理'
      },
      component: () => import('@/views/inner'),
      children: [
        // 汇入汇款申报
        {
          path: 'declare',
          name: 'DeclareInner',
          meta: {
            id: '10101300',
            title: '汇入汇款申报'
          },
          component: () => import('@/views/inner/transfer'),
          redirect: '/inner/transfer/declare/query',
          children: [
            {
              path: 'query',
              name: 'DeclareInnerQuery',
              meta: {
                title: ''
              },
              component: () => import('@/views/inner/transfer/declare/Query')
            },
            {
              path: 'add',
              name: 'DeclareInnerAdd',
              meta: {
                title: '新增汇入汇款申报'
              },
              component: () => import('@/views/inner/transfer/declare/Add')
            },
            {
              path: 'detail',
              name: 'DeclareInnerDetail',
              meta: {
                title: '汇入汇款申报详情'
              },
              component: () => import('@/views/inner/transfer/declare/Add')
            },
            {
              path: 'update',
              name: 'DeclareInnerUpdate',
              meta: {
                title: '修改汇入汇款申报'
              },
              component: () => import('@/views/inner/transfer/declare/Add')
            },
            {
              path: 'msbd-add',
              name: 'DeclareInnerMsbdAdd',
              meta: {
                title: '新增电商类汇入汇款申报'
              },
              component: () => import('@/views/inner/transfer/declare/AddMsbd')
            },
            {
              path: 'msbd-detail',
              name: 'DeclareInnerMsbdDetail',
              meta: {
                title: '电商类汇入汇款申报详情'
              },
              component: () => import('@/views/inner/transfer/declare/AddMsbd')
            },
            {
              path: 'msbd-update',
              name: 'DeclareInnerMsbdUpdate',
              meta: {
                title: '更新电商类汇入汇款申报'
              },
              component: () => import('@/views/inner/transfer/declare/AddMsbd')
            }
          ]
        },
        // 交易核查
        {
          path: 'check',
          name: 'CheckInner',
          meta: {
            id: '20210630',
            title: '交易核查'
          },
          component: () => import('@/views/inner/transfer'),
          redirect: '/inner/transfer/check/list',
          children: [
            // 交易核查列表
            {
              path: 'list',
              name: 'CheckInnerList',
              meta: {
                title: ''
              },
              component: () => import('@/views/inner/transfer/check')
            },
            // 交易核查详情
            {
              path: 'details',
              name: 'CheckInnerDetails',
              meta: {
                title: '交易核查详情'
              },
              component: () => import('@/views/inner/transfer/check/details')
            }
          ]
        },
        // 汇入路径查询
        {
          path: 'path-query',
          name: 'PathQueryInner',
          meta: {
            id: '10100101',
            title: '汇入路径查询'
          },
          component: () => import('@/views/inner/transfer'),
          redirect: '/inner/transfer/path-query/query',
          children: [
            // 路径查询
            {
              path: 'query',
              name: 'PathQueryInnerQuery',
              meta: {
                title: ''
              },
              component: () => import('@/views/inner/transfer/pathQuery/Query')
            },
            // 路径申请(这一部分后续有需要的话 可以迁移至commonRoutes)
            {
              path: 'apply',
              name: 'PathQueryInnerApply',
              meta: {
                title: '汇入路径申请'
              },
              component: () => import('@/views/inner/transfer/pathQuery/apply')
            },
            {
              path: 'apply-c',
              name: 'PathQueryInnerApplyC',
              meta: {
                title: '贸易收款申请'
              },
              component: () => import('@/views/inner/transfer/pathQuery/apply/ApplyC')
            },
            {
              path: 'apply-d',
              name: 'PathQueryInnerApplyD',
              meta: {
                title: '电商收款申请'
              },
              component: () => import('@/views/inner/transfer/pathQuery/apply/ApplyD')
            },
            {
              path: 'apply-result',
              name: 'PathQueryInnerApplyResult',
              meta: {
                title: '结果'
              },
              component: () => import('@/views/inner/transfer/pathQuery/apply/ApplyResult')
            }
          ]
        }
      ]
    }
  ]
}
